import { CompassCardUI } from '@scale/compass-ui/types';
import {
  ExplainQueueCardShared,
  type ExplainQueueSchemaType,
  type ExplainQueueContext,
  EXPLAIN_QUEUE,
} from '@scale/genai-compass-shared/cards/explain_queue';
import ExplainQueueCardComponent from './ExplainQueueCardComponent';
import { faGauge } from '@fortawesome/pro-solid-svg-icons';

export const EXPLAIN_QUEUE_SAMPLE_SIZE = 20;

const defaultContext: ExplainQueueContext = {
  cardType: EXPLAIN_QUEUE,
  selectedColumnId: undefined,
};

export const ExplainQueueCardInfo: CompassCardUI<ExplainQueueSchemaType> = {
  ...ExplainQueueCardShared,
  title: 'Explain Queue',
  icon: 'message-question',
  toolTip:
    'Select a column containing *worker ids* and run a live explain queue to retrieve *assignments* and *empty queue reasons*.',
  defaultContext,
  ownerTeam: 'Allocation',
  legacyComponent: ExplainQueueCardComponent,
  button: {
    icon: faGauge,
  },
};
